import { reactive, toRefs, provide, inject } from "@vue/composition-api";
import { debounce } from "throttle-debounce";
import axios from "axios";
import {formatSysDateTime} from "@/plugins/formatting";

export const state = reactive({
    taskButtons: [],
    taskButtonsPersonal: [],
    currentAccountId: null
});

export const actions = {
    async fetchTaskButtons(account_id) {
        const { data } = await axios.get(`/task-buttons/${account_id}`);
        state.taskButtons = data;
    },
    async fetchTaskButtonsPersonal() {
        const { data } = await axios.get("/task-buttons/personal");
        state.taskButtonsPersonal = data;
    },
    async createTaskButton(id, billable) {
        const { data } = await axios.post(`/task-button/start/${id}`, {
            due_date: formatSysDateTime(new Date()),
            billable: billable
        });

        return data;
    },
    async changeButtonOrder(account_id) {
        const payload = {
            task_buttons_ordered_ids_list: state.taskButtons.map(x => x.id)
        };

        const debouncedRequest = debounce(1000, false, async () => {
            await axios.post("/task-button/sort_order/", payload);
        });

        debouncedRequest();
    },
    async changeButtonVisibility(id, is_visible) {
        const payload = { task_button_id: id, is_visible: is_visible };

        const debouncedRequest = debounce(1000, false, async () => {
            await axios.post("/task-button/visibility/", payload);
        });

        debouncedRequest();
    },
    setCurrentAccountId(id) {
        state.currentAccountId = id;
    }
};

export const getters = {};

export const key = Symbol("TaskButtonModule");

export const provideTaskButton = () =>
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });

export default () => inject(key);
